import React, { useState, FormEvent, useContext, useEffect } from "react";
import {
  Segment,
  Form,
  Button,
  Input,
  Select,
  Grid,
  Label,
  Header,
  Radio,
} from "semantic-ui-react";
import TechnicianTransmissionStore from "../../../app/stores/techniciantransmissionStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";
import { ITransmissionChecklist } from "../../../app/models/transmissionchecklist";

interface DetailParams {
  id: string;
}

const TechnicianTransmissionChecklistForm: React.FC<
  RouteComponentProps<DetailParams>
> = ({ match, history }) => {
  const techniciantransmissionStore = useContext(TechnicianTransmissionStore);
  const {
    submitting,
    loadTechnicianTransmission,
    clearTechnicianTransmission,
    createTransmissionChecklist,
    loadTechnicians,
    technicianRegistry,
  } = techniciantransmissionStore;

  const [transmissionchecklist, setTransmissionChecklist] =
    useState<ITransmissionChecklist>({
      siteId: "",
      siteName: "",
      siteAddress: "",
      siteType: "",
      company: "Efiniti",
      contractorName: "",
      phoneNumber: "",
      ptid: "061AFBC0244901",
      startDate: "",
      completionDate: "",
      completedBy: "",
      assessmentType: "Self Assessment",
      ohsEnvReq: "Yes",
      ohsRisk: "Yes",
      ohsSiteLog: "Yes",
      ohsSwms: "Yes",
      ohsSiteAccess: "Yes",
      hazardCrq: "Yes",
      hazardNoc: "Yes",
      hazardSecurity: "Yes",
      grOne: "N/A",
      grTwo: "N/A",
      grThree: "N/A",
      toolAll: "Yes",
      toolEsd: "Yes",
      refSite: "Yes",
      refNokia: "Yes",
      refEquip: "Yes",
      siteCheckVha: "Yes",
      siteCheckRack: "Yes",
      siteCheckPower: "Yes",
      siteCheckFibre: "Yes",
      siteCheckPhoto: "Yes",
      smrIronwork: "N/A",
      smrCable: "N/A",
      smrFibre: "N/A",
      rackChecked: "N/A",
      rackInstalled: "N/A",
      rackFloor: "N/A",
      rackWall: "N/A",
      equipSubrack: "Yes",
      equipDelivered: "Yes",
      equipInstalled: "Yes",
      equipSecured: "Yes",
      equipPhoto: "Yes",
      cardsCheck: "Yes",
      cardsDelivered: "Yes",
      cardsFibre: "Yes",
      cardsSlack: "Yes",
      cardsSecure: "Yes",
      cardsPhoto: "Yes",
      cardsConnection: "Yes",
      labelPower: "Yes",
      labelPDU: "Yes",
      externalNokia: "N/A",
      externalDWDM: "N/A",
      externalConnection: "N/A",
      dcEltek: "N/A",
      dcNokia: "Yes",
      dcCableRouted: "Yes",
      dcCableTerminated: "Yes",
      dcInstalled: "Yes",
      dcLegend: "Yes",
      dcEquipment: "Yes",
      dcActive: "Yes",
      earthCable: "Yes",
      earthEquipment: "Yes",
      earthRack: "Yes",
      ethernetTerminated: "N/A",
      ethernetInstalled: "N/A",
      ethernetRoute: "N/A",
      ethernetIsolated: "N/A",
      finalInspecCabling: "Yes",
      finalInspecUnconnectedFibre: "Yes",
      finalInspecSpareFibre: "Yes",
      finalInspecDWDMDebries: "Yes",
      finalInspecImmediateDebries: "Yes",
      finalInspecDoors: "Yes",
      finalInspecSites: "Yes",
      defectsNo: "0",
      ifZeroDefects: "Yes",
      rackHuawei: "NO",
      rackHuaweiSerialNum: "",
      rackIxre: "NA",
      rackIxreSerialNum: "",
    });

  const [numOfDefects, setDefectsNum] = useState("0");
  const [zeroDefects, setZeroDefects] = useState("Yes");

  const technicianOptions = Array.from(technicianRegistry.values()).map(function (tech) {
    var option = { "key": tech.email, "text": tech.name, "value": tech.email }
    return option;
  }
  );

  const siteTypeOptions = [
    { key: "POC1", text: "POC1", value: "POC1" },
    { key: "POC2", text: "POC2", value: "POC2" },
    { key: "POC3", text: "POC3", value: "POC3" },
    { key: "POC4", text: "POC4", value: "POC4" },
  ];

  const assessmentTypeOptions = [
    {
      key: "Self Assessment",
      text: "Self Assessment",
      value: "Self Assessment",
    },
    { key: "Remote Audit", text: "Remote Audit", value: "Remote Audit" },
    { key: "Physical Audit", text: "Physical Audit", value: "Physical Audit" },
  ];

  const recoveredOptions = [
    { key: "YES", text: "YES", value: "YES" },
    { key: "NO", text: "NO", value: "NO" },
    { key: "NA", text: "NA", value: "NA" },
  ];

  useEffect(() => {
    loadTechnicianTransmission(match.params.id).then(
      (techniciantransmission) => {
        setTransmissionChecklist({
          ...transmissionchecklist,
          ["siteId"]: techniciantransmission.projectSite.siteId,
          ["siteName"]: techniciantransmission.projectSite.siteName,
          ["siteAddress"]: techniciantransmission.projectSite.address,
        });
      }
    );

    loadTechnicians();

    return () => {
      clearTechnicianTransmission();
    };
  }, [loadTechnicianTransmission]);

  useEffect(() => {
    let property: keyof ITransmissionChecklist;
    let n = 0;
    for (property in transmissionchecklist) {
      if (transmissionchecklist[property] === "No") {
        n += 1;
      }
    }
    setDefectsNum(n.toString());
    if (n !== 0) {
      setZeroDefects("NO");
    } else {
      setZeroDefects("Yes");
    }
  });

  const handleSubmit = () => {
    let updatedTransmissionChecklist: ITransmissionChecklist;
    updatedTransmissionChecklist = {
      ...transmissionchecklist,
      defectsNo: numOfDefects,
      ifZeroDefects: zeroDefects,
    };
    createTransmissionChecklist(updatedTransmissionChecklist).then(() =>
      history.push(`/employeeportal/techniciantransmission`)
    );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setTransmissionChecklist({ ...transmissionchecklist, [name]: value });
  };

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Header as="h3">Project Details</Header>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Site Id:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={handleInputChange}
              name="siteId"
              fluid
              readonly
              value={transmissionchecklist.siteId}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Site Name:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={handleInputChange}
              name="siteName"
              fluid
              readonly
              value={transmissionchecklist.siteName}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Site Address:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={handleInputChange}
              name="siteAddress"
              readonly
              fluid
              value={transmissionchecklist.siteAddress}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Site Type:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Select
              onChange={(e, { name, value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  [name]: value,
                });
              }}
              options={siteTypeOptions}
              name="siteType"
            />
          </Grid.Column>
        </Grid>
        <br></br>
        <Header as="h3">Contractor Details</Header>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Company:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={handleInputChange}
              name="company"
              fluid
              value={transmissionchecklist.company}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Contractor Name:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
          <Select
              onChange={(e, { name, value}) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  [name]: technicianRegistry.get(value).name,
                  ["phoneNumber"]: technicianRegistry.get(value).mobile,
                  // ["ptid"]: technicianRegistry.get(Number(value)).ptid,
                  ["completedBy"]: technicianRegistry.get(value).name,
                });
                // console.log(e.target);
                // console.log(e.currentTarget.accessKey);
                // setTransmissionChecklist({
                //   ...transmissionchecklist,
                //   ["phoneNumber"]: technicianRegistry.get(Number(value)).mobile,
                // });
              }}
              options={technicianOptions}
              name="contractorName"
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Phone Number:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={handleInputChange}
              name="phoneNumber"
              fluid
              value={transmissionchecklist.phoneNumber}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">PTID Number:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={handleInputChange}
              name="ptid"
              fluid
              value={transmissionchecklist.ptid}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Site Start Date - Actual:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={handleInputChange}
              name="startDate"
              type="date"
              value={transmissionchecklist.startDate}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Site Completion Date - Actual:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={handleInputChange}
              name="completionDate"
              type="date"
              value={transmissionchecklist.completionDate}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">Assessment Details</Header>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Completed By:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={handleInputChange}
              name="completedBy"
              fluid
              value={transmissionchecklist.completedBy}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Assessment Type:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Select
              onChange={(e, { name, value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  [name]: value,
                });
              }}
              options={assessmentTypeOptions}
              name="assessmentType"
              value={transmissionchecklist.assessmentType}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">Rack Layouts</Header>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">OLD - Huawei ATN910i </Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={12} computer={12}>
            <Form.Group>
              <Form.Select
                label="Recovered"
                onChange={(e, { name, value }) =>
                  setTransmissionChecklist({
                    ...transmissionchecklist,
                    [name]: value,
                  })
                }
                name="rackHuawei"
                placeholder="Recovered"
                options={recoveredOptions}
                value={transmissionchecklist.rackHuawei}
                width={4}
              />
              <Form.Input
                label="Serial Number"
                onChange={handleInputChange}
                name="rackHuaweiSerialNum"
                placeholder="Serial Number"
                value={transmissionchecklist.rackHuaweiSerialNum}
                width={4}
              />
            </Form.Group>
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">NEW - 7250 IXRe </Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={12} computer={12}>
            <Form.Group>
              <Form.Select
                label="Recovered"
                onChange={(e, { name, value }) =>
                  setTransmissionChecklist({
                    ...transmissionchecklist,
                    [name]: value,
                  })
                }
                name="rackIxre"
                placeholder="Recovered"
                options={recoveredOptions}
                value={transmissionchecklist.rackIxre}
                width={4}
              />
              <Form.Input
                label="Serial Number"
                onChange={handleInputChange}
                name="rackIxreSerialNum"
                placeholder="Serial Number"
                value={transmissionchecklist.rackIxreSerialNum}
                width={4}
              />
            </Form.Group>
          </Grid.Column>
        </Grid>

        <Header as="h3">5. OHS&E Requirements</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All OH&S and Environmental requirements completed/adhered to.
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.ohsEnvReq === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsEnvReq"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.ohsEnvReq === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsEnvReq"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.ohsEnvReq === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsEnvReq"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={6}
          >
            Risk management completed for each site visit. (JSEA/SWMS). JSEA
            must be stored and made available for NOKIA on request File name
            example: 35WA_JSEA_Commissioning
          </Grid.Column>
          <Grid.Column width="1"></Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.ohsRisk === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsRisk"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.ohsRisk === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsRisk"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.ohsRisk === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsRisk"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Site log book completed.
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.ohsSiteLog === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsSiteLog"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.ohsSiteLog === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsSiteLog"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.ohsSiteLog === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsSiteLog"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            SWMS induction completed for all staff attending site
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.ohsSwms === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsSwms"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.ohsSwms === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsSwms"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.ohsSwms === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsSwms"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Site access is clear/unobstructed
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.ohsSiteAccess === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsSiteAccess"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.ohsSiteAccess === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsSiteAccess"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.ohsSiteAccess === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ohsSiteAccess"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">6. Hazard Notification</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Valid CRQ number obtained with correct details
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.hazardCrq === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["hazardCrq"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.hazardCrq === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["hazardCrq"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.hazardCrq === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["hazardCrq"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            SWMS induction completed for all staff attending site
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.hazardNoc === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["hazardNoc"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.hazardNoc === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["hazardNoc"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.hazardNoc === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["hazardNoc"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Site access is clear/unobstructed
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.hazardSecurity === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["hazardSecurity"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.hazardSecurity === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["hazardSecurity"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.hazardSecurity === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["hazardSecurity"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">7. Good Receipting (GR)</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Onsite 1 GR – One (1) Geo tagged photo of equipment at VHA site.
            <br></br>
            Photo includes all site items packed in boxes (multiple items)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.grOne === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["grOne"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.grOne === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["grOne"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.grOne === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["grOne"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Onsite 2 GR – One (1) Geo tagged photo of equipment onsite<br></br>
            Photo includes all items UNPACKED (multiple items)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.grTwo === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["grTwo"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.grTwo === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["grTwo"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.grTwo === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["grTwo"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Onsite 3 GR – One (1) Geo tagged photo of equipment installed onsite
            - <br></br>
            Photo includes all site items installed (multiple items)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.grThree === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["grThree"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.grThree === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["grThree"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.grThree === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["grThree"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">8. Tools and Test Equipment</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All 240V equipment tested and tagged (within test due date).
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.toolAll === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["toolAll"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.toolAll === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["toolAll"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.toolAll === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["toolAll"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            ESD wrist strap tested and used where required<br></br>
            All Technicians on site handling ESD sensitive equipment must use a
            tested wrist strap, <br></br>
            add technicians names to the comments field.
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.toolEsd === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["toolEsd"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.toolEsd === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["toolEsd"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.toolEsd === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["toolEsd"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">9. Reference documentation</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Site Design
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.refSite === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["refSite"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.refSite === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["refSite"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.refSite === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["refSite"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Nokia Standards Document (VHA Transmission Replacement Design{" "}
            <br></br>
            and Installation Information)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.refNokia === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["refNokia"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.refNokia === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["refNokia"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.refNokia === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["refNokia"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Equipment Installation & Commissioning Guides
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.refEquip === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["refEquip"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.refEquip === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["refEquip"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.refEquip === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["refEquip"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">10. Site Readiness and Allocation Check</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            VHA site and environment clean and suitable for installation.
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.siteCheckVha === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckVha"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.siteCheckVha === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckVha"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.siteCheckVha === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckVha"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Rack allocations free and available
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.siteCheckRack === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckRack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.siteCheckRack === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckRack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.siteCheckRack === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckRack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Power allocations free and available
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.siteCheckPower === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckPower"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.siteCheckPower === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckPower"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.siteCheckPower === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckPower"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Fibre allocations free and available
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.siteCheckFibre === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.siteCheckFibre === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.siteCheckFibre === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Photo (1) taken of each allocated rack position before new rack
            installation <br></br>
            (full rack view showing ironwork above)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.siteCheckPhoto === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckPhoto"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.siteCheckPhoto === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckPhoto"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.siteCheckPhoto === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["siteCheckPhoto"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">11. Site Make Ready</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Ironwork (wall bar etc) installed/modified as per design and{" "}
            <br></br>
            section 4 of the Nokia guidelines (min 1 photo)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.smrIronwork === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["smrIronwork"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.smrIronwork === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["smrIronwork"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.smrIronwork === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["smrIronwork"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Cable Tray installed/modified as stated in design (min 1 photo)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.smrCable === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["smrCable"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.smrCable === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["smrCable"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.smrCable === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["smrCable"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Optical Fibre Ducting installed/modified as per design (min 1 photo)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.smrFibre === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["smrFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.smrFibre === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["smrFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.smrFibre === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["smrFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">12. Rack Installation</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            NOKIA ETSI Rack uncrated and checked for physical damage
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.rackChecked === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackChecked"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.rackChecked === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackChecked"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.rackChecked === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackChecked"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            NOKIA ETSI Rack Installed in correct location as per design (Z1)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.rackInstalled === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.rackInstalled === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.rackInstalled === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            NOKIA ETSI Rack secured correctly to floor as per section 4<br></br>{" "}
            of the Nokia guidelines (1 photo) (Z2)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.rackFloor === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackFloor"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.rackFloor === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackFloor"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.rackFloor === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackFloor"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            NOKIA ETSI Rack secured correctly to wall as per section 4 <br></br>
            of the Nokia guidelines (1 photo) (Z2)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.rackWall === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackWall"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.rackWall === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackWall"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.rackWall === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["rackWall"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">13. Equipment Validation / Installation</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All Sub racks and associated equipment checked for physical damage
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.equipSubrack === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipSubrack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.equipSubrack === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipSubrack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.equipSubrack === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipSubrack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All Equipment delivered in Nokia ETSI One Rack as specified in
            design.
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.equipDelivered === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipDelivered"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.equipDelivered === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipDelivered"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.equipDelivered === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipDelivered"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All Equipment installed into VHA Rack as specified in design. (Z4)
            (Z14)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.equipInstalled === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.equipInstalled === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.equipInstalled === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All Equipment secured correctly into VHA Rack (Z16)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.equipSecured === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipSecured"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.equipSecured === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipSecured"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.equipSecured === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipSecured"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Photo taken of each rack showing sub rack layout (min 1 photo)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.equipPhoto === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipPhoto"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.equipPhoto === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipPhoto"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.equipPhoto === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["equipPhoto"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">14. Cards and Internal Fibres</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Visual check of cards and internal fibres.
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.cardsCheck === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsCheck"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.cardsCheck === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsCheck"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.cardsCheck === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsCheck"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All cards and fibres delivered in sub racks as specified in design.
            (Z24)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.cardsDelivered === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsDelivered"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.cardsDelivered === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsDelivered"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.cardsDelivered === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsDelivered"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Internal fibres routed without excessive slack or tightness,{" "}
            <br></br>
            and with appropriate bend radii (Z25)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.cardsFibre === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.cardsFibre === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.cardsFibre === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Excess fibre slack is neatly managed in fibre storage tray(s) (Z26)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.cardsSlack === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsSlack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.cardsSlack === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsSlack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.cardsSlack === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsSlack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Non-ruggedised fibres are secured using velcro, not cable ties (Z25)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.cardsSecure === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsSecure"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.cardsSecure === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsSecure"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.cardsSecure === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsSecure"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Photo taken of each sub rack showing card and fibre layout (min 1
            photo)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.cardsPhoto === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsPhoto"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.cardsPhoto === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsPhoto"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.cardsPhoto === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsPhoto"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Fibre connection; male and female cleaned, tested (showing pass and
            id) <br></br>
            and photographed
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.cardsConnection === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsConnection"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.cardsConnection === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsConnection"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.cardsConnection === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["cardsConnection"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">15. Labelling</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Power, Earth, Ethernet, Fibre cables labelling completed (both ends
            labelled with correct label type) - Photos taken (Z15)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.labelPower === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["labelPower"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.labelPower === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["labelPower"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.labelPower === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["labelPower"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            PDU and sub racks labelling completed in accordance with Nokia
            guidelines - Photos taken (Z5) (Z17)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.labelPDU === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["labelPDU"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.labelPDU === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["labelPDU"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.labelPDU === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["labelPDU"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">16. External Fibering</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Ruggedised fibres between Nokia equipment and LGX (ODF) or Tie Cable
            at exchange sites installed as per design
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.externalNokia === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["externalNokia"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.externalNokia === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["externalNokia"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.externalNokia === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["externalNokia"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Ruggedised fibres between DWDM racks at exchange sites installed as
            per design
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.externalDWDM === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["externalDWDM"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.externalDWDM === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["externalDWDM"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.externalDWDM === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["externalDWDM"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Fibre connection; male and female cleaned, tested (showing pass and
            id) and photographed
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.externalConnection === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["externalConnection"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.externalConnection === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["externalConnection"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.externalConnection === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["externalConnection"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">17. DC Power</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            New Eltek PDU installed in Tx rack as specified in design. (Z4)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.dcEltek === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcEltek"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.dcEltek === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcEltek"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.dcEltek === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcEltek"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Existing PDU is installed safely and suitable for Nokia use.
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.dcNokia === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcNokia"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.dcNokia === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcNokia"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.dcNokia === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcNokia"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Power cable routed and installed as per design - Correct cable size,
            feeds from separate CBs (or different separate rectifier racks if
            eJV) (Z6)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.dcCableRouted === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcCableRouted"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.dcCableRouted === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcCableRouted"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.dcCableRouted === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcCableRouted"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Power cables terminated at PDU as per design (min 1 photo)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.dcCableTerminated === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcCableTerminated"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.dcCableTerminated === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcCableTerminated"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.dcCableTerminated === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcCableTerminated"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            CB's in PDU installed as per design - correct size. (Z7)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.dcInstalled === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.dcInstalled === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.dcInstalled === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            PDU legend sheet correct and printed (not hand written) (Z8)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.dcLegend === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcLegend"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.dcLegend === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcLegend"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.dcLegend === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcLegend"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All equipment power cables routed appropriately and secured using
            cable ties/cable minder (Z10) (Z11)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.dcEquipment === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcEquipment"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.dcEquipment === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcEquipment"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.dcEquipment === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcEquipment"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All active equipment Power Up Checked completed - and left TURNED ON
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.dcActive === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcActive"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.dcActive === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcActive"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.dcActive === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["dcActive"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">18. Earthing</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Rack EARTH cable Installed and lugged as per Nokia design (correct
            cable size)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.earthCable === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["earthCable"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.earthCable === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["earthCable"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.earthCable === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["earthCable"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All active equipment earthed to Earth bar as per Nokia design (Z18)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.earthEquipment === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["earthEquipment"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.earthEquipment === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["earthEquipment"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.earthEquipment === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["earthEquipment"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Rack earthed correctly as per Nokia design (Z3)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.earthRack === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["earthRack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.earthRack === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["earthRack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.earthRack === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["earthRack"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">19. Ethernet Cabling</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Ethernet cables are terminated as per Nokia guidelines (Z22)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.ethernetTerminated === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetTerminated"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.ethernetTerminated === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetTerminated"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.ethernetTerminated === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetTerminated"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Ethernet cables are installed as per design (Z22)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.ethernetInstalled === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.ethernetInstalled === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.ethernetInstalled === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetInstalled"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Ethernet cables are routing is neat and using cable tray/minder
            (Z23)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.ethernetRoute === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetRoute"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.ethernetRoute === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetRoute"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.ethernetRoute === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetRoute"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            Ethernet cables are isolated from DC cables (Z23)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.ethernetIsolated === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetIsolated"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.ethernetIsolated === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetIsolated"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.ethernetIsolated === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["ethernetIsolated"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">20. Final Inspection & Site Completion</Header>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All cabling is tidy and secured., with no redundant cables present
            (Z32)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.finalInspecCabling === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecCabling"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.finalInspecCabling === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecCabling"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.finalInspecCabling === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecCabling"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All unconnected fibre cables have protective covers (Z28)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={
                transmissionchecklist.finalInspecUnconnectedFibre === "Yes"
              }
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecUnconnectedFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={
                transmissionchecklist.finalInspecUnconnectedFibre === "No"
              }
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecUnconnectedFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={
                transmissionchecklist.finalInspecUnconnectedFibre === "N/A"
              }
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecUnconnectedFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All spare fibre termination ports are protected with protective
            covers (Z27)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.finalInspecSpareFibre === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecSpareFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.finalInspecSpareFibre === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecSpareFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.finalInspecSpareFibre === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecSpareFibre"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All debris removed from the DWDM cabinet (dirt, broken cable ties
            etc)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.finalInspecDWDMDebries === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecDWDMDebries"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.finalInspecDWDMDebries === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecDWDMDebries"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.finalInspecDWDMDebries === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecDWDMDebries"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All debris removed from the immediate area (packaging etc)
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={
                transmissionchecklist.finalInspecImmediateDebries === "Yes"
              }
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecImmediateDebries"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={
                transmissionchecklist.finalInspecImmediateDebries === "No"
              }
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecImmediateDebries"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={
                transmissionchecklist.finalInspecImmediateDebries === "N/A"
              }
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecImmediateDebries"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All doors correctly closed and locked.
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.finalInspecDoors === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecDoors"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.finalInspecDoors === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecDoors"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.finalInspecDoors === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecDoors"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="left"
            verticalAlign="middle"
            mobile={10}
            tablet={7}
            computer={7}
          >
            All site works completed, documentation completed (red line mark up
            as required to design), matrix updated
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="Yes"
              value="Yes"
              checked={transmissionchecklist.finalInspecSites === "Yes"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecSites"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="No"
              value="No"
              checked={transmissionchecklist.finalInspecSites === "No"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecSites"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={2} tablet={1} computer={1}>
            <Radio
              label="N/A"
              value="N/A"
              checked={transmissionchecklist.finalInspecSites === "N/A"}
              onChange={(e, { value }) => {
                setTransmissionChecklist({
                  ...transmissionchecklist,
                  ["finalInspecSites"]: value!.toString(),
                });
              }}
            />
          </Grid.Column>
        </Grid>
        <Header as="h3">21: Summary</Header>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Number of defects:</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={(e) => {
                setDefectsNum(e.target.value);
              }}
              readonly
              name="defectsNo"
              fluid
              value={numOfDefects}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column
            textAlign="right"
            verticalAlign="middle"
            mobile={3}
            tablet={2}
            computer={2}
          >
            <Header as="h6">Zero Defect (ZD) target met (Yes/No):</Header>
          </Grid.Column>
          <Grid.Column mobile={12} tablet={8} computer={8}>
            <Input
              onChange={(e) => {
                setZeroDefects(e.target.value);
              }}
              readonly
              name="ifZeroDefects"
              fluid
              value={zeroDefects}
            />
          </Grid.Column>
        </Grid>

        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/employeeportal/techniciantransmission")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(TechnicianTransmissionChecklistForm);
